import { Component, OnInit,ViewChild } from '@angular/core';
import { mobileVerification } from '../models/mobileVerification';
import { currentInventory } from '../models/currentInventory';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Router } from '@angular/router';

const URL = 'http://localhost:4500/api/upload';
@Component({
  selector: 'app-mobileverification',
  templateUrl: './mobileverification.component.html',
  styleUrls: ['./mobileverification.component.css']
})
export class MobileVerificationComponent implements OnInit {
  title = 'ng8fileupload';
  mobileVerifyAddObj:mobileVerification
  @ViewChild("verifyForm") form: any;

  constructor(private router: Router, private toastr: ToastrManager,private cs:CucurachaAdminService) { 
    this.mobileVerifyAddObj=new mobileVerification()
  }
  verifyMobileNumber(){
    this.cs.verifyMobileNumber(this.mobileVerifyAddObj).subscribe((data) => {
      console.log(data)
      if (data.result) {
        this.router.navigate(['mainview/dashboard']);
        this.toastr.successToastr("LoggedIn SuccessFully");
     
      }
     
      else {
        this.toastr.errorToastr(data.message);

      }
    })
  }
  ngOnInit() {
   
    };
 

}
